const PingHandlerActionTypes = {
  PING_START: 'PING_START',
  PING_SUCCESS: 'PING_SUCCESS',
  PING_FAILURE: 'PING_FAILURE',

  PING_BY_ID_START: 'PING_BY_ID_START',
  PING_BY_ID_SUCCESS: 'PING_BY_ID_SUCCESS',
  PING_BY_ID_FAILURE: 'PING_BY_ID_FAILURE',

  SET_CURR_SOURCE: 'SET_CURR_SOURCE',
  SET_CURR_TARGETS: 'SET_CURR_TARGETS',
};

export default PingHandlerActionTypes;
